import axios from 'axios';
import get from 'lodash/get';

async function loadTranslation(language, baseUrl) {
  try {
    const response = await axios.get(`${baseUrl}/lang/lang-${language}.json`);
    return response.data;
  } catch {
    return {};
  }
}

const TranslationStore = {
  baseUrl: '',
  labels: {},

  setBaseUrl(baseUrl) {
    this.baseUrl = baseUrl;
  },

  async loadTranslations(language) {
    this.labels = await loadTranslation(language, this.baseUrl);
  },

  get(label) {
    return get(this.labels, label, label);
  },
};

export default TranslationStore;
